(function () {
  'use strict';

  var MENU_ID = 'responsiveMenu';
  var MORE_CLASS = 'gm-nav-more';
  var OVERFLOW_CLASS = 'gm-nav-overflow-original';
  var MID_MIN = 1200;
  var MID_MAX = 1399;

  var labels = {
    cs: 'Více',
    de: 'Mehr',
    en: 'More',
    pt: 'Mais',
    es: 'Más',
    fr: 'Plus',
    it: 'Altro',
    ja: 'その他',
    nl: 'Meer',
    pl: 'Więcej',
    ro: 'Mai multe',
    sk: 'Viac'
  };

  function languageCode() {
    return (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  }

  function directRootItems(menu) {
    return Array.prototype.filter.call(menu.children, function (item) {
      return item.tagName === 'LI' && item.classList.contains('parent-level') && !item.classList.contains(MORE_CLASS);
    });
  }

  function hasDirectSubmenu(item) {
    return Array.prototype.some.call(item.children, function (child) {
      return child.tagName === 'UL';
    });
  }

  function childLinkFrom(sourceItem) {
    var sourceLink = sourceItem.firstElementChild;
    if (!sourceLink || sourceLink.tagName !== 'A') return null;

    var item = document.createElement('li');
    item.className = 'child-level three';

    var link = document.createElement('a');
    link.className = 'child';
    link.href = sourceLink.href;
    link.setAttribute('role', 'menuitem');
    link.title = sourceLink.title || sourceLink.textContent.trim();

    if (sourceLink.target) link.target = sourceLink.target;
    if (sourceLink.getAttribute('aria-current')) {
      link.setAttribute('aria-current', sourceLink.getAttribute('aria-current'));
      link.classList.add('active');
    }

    var text = document.createElement('span');
    text.textContent = sourceLink.textContent.trim();
    link.appendChild(text);
    item.appendChild(link);
    return item;
  }

  function prepareMenu(menu) {
    if (!menu || menu.getAttribute('data-gm-nav-more-ready') === 'true') return;

    var rootItems = directRootItems(menu);
    if (rootItems.length < 6) return;

    var overflowItems = rootItems.slice(-2);
    if (overflowItems.some(hasDirectSubmenu)) return;

    var moreItem = document.createElement('li');
    moreItem.className = 'parent-level parent has-dropdown keydown relative last ' + MORE_CLASS;
    moreItem.style.display = 'none';

    var moreLink = document.createElement('a');
    moreLink.href = '#';
    moreLink.className = 'parent';
    moreLink.setAttribute('role', 'menuitem');
    moreLink.setAttribute('aria-haspopup', 'true');
    moreLink.setAttribute('aria-expanded', 'false');

    var label = labels[languageCode()] || labels.en;
    moreLink.title = label;
    moreLink.setAttribute('aria-label', label);

    var moreText = document.createElement('span');
    moreText.textContent = label;
    moreLink.appendChild(moreText);
    moreLink.addEventListener('click', function (event) {
      event.preventDefault();
    });

    var alignment = 'right';
    ['left', 'center', 'right'].some(function (value) {
      if (menu.classList.contains('text-' + value)) {
        alignment = value;
        return true;
      }
      return false;
    });

    var dropdown = document.createElement('ul');
    dropdown.className = 'parent-level-ul dropdown text-' + alignment;
    dropdown.setAttribute('role', 'menu');

    var inner = document.createElement('span');
    overflowItems.forEach(function (sourceItem) {
      sourceItem.classList.add(OVERFLOW_CLASS);
      var child = childLinkFrom(sourceItem);
      if (child) inner.appendChild(child);
    });

    if (!inner.children.length) return;

    dropdown.appendChild(inner);
    moreItem.appendChild(moreLink);
    moreItem.appendChild(dropdown);

    var localizationItem = Array.prototype.find.call(menu.children, function (item) {
      return item.classList && item.classList.contains('localization');
    });
    menu.insertBefore(moreItem, localizationItem || null);
    menu.setAttribute('data-gm-nav-more-ready', 'true');

    function applyMode() {
      var width = window.innerWidth || document.documentElement.clientWidth;
      var useMore = width >= MID_MIN && width <= MID_MAX && !(window.theme && window.theme.detectmob);

      overflowItems.forEach(function (item) {
        item.style.display = useMore ? 'none' : '';
      });
      moreItem.style.display = useMore ? 'inline-table' : 'none';
      menu.classList.toggle('gm-nav-more-active', useMore);
    }

    applyMode();
    window.addEventListener('resize', applyMode, { passive: true });
  }

  prepareMenu(document.getElementById(MENU_ID));

  document.addEventListener('shopify:section:load', function (event) {
    var menu = event.target && event.target.querySelector ? event.target.querySelector('#' + MENU_ID) : null;
    if (menu) prepareMenu(menu);
  });
}());
